import httpClient from '../../http';

const getNotifications = async () => {
  const notifications = (await httpClient.get('/notification?days=5&limit=5')).data;
  if (!notifications) return null;
  return notifications;
};

export { getNotifications };
